import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useT } from "contexts/TranslationContext";

const SuccessPage = () => {
  const t = useT();

  useEffect(() => {
    localStorage.removeItem("selectedPlan");
  }, []);

  //save to db that user has successfully subscribed
  const saveSubscription = async () => {
    try {
      const response = await fetch('/api/subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // body: JSON.stringify({ email: user.email }),
      });
      if (!response.ok) {
        throw new Error('Failed to save subscription');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen bg-green-50 p-6">
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs={12} sm={8} md={6} lg={4} sx={{ textAlign: 'center' }}>
          <div className="bg-white shadow-lg rounded-2xl p-8 text-center">
            
            {/* SVG inside a small container */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={180}   // Fixed width
              height={180}  // Fixed height
              mx="auto"
              mb={6}
            >
              <svg
                width="100%"
                height="100%"
                fill="none"
                stroke="#4CAF50"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </Box>

            <h1 className="text-2xl font-bold mb-2 text-green-800">{t("success.title")}</h1>
            <p className="text-gray-700 mb-6">
              {t("success.message")}
            </p>

            {/* MUI button */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => (window.location.href = '/')}
              sx={{
                backgroundColor: "#4CAF50",
                '&:hover': {
                  backgroundColor: "#256b4f",
                },
                borderRadius: '9999px',
                px: 3,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 'bold',
              }}
            >
              {t("success.back")}
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SuccessPage;
